<template>
    <template v-if="mainNav.showNav">
        <div class="nav-type-1-spacer"></div>
        <div 
            :class="['nav-type-1', 'container-fluid', { open: navExpanded }]"
            ref="topNav"
        >
            <div class="container">
                <div class="nav-left">
                    <router-link :to="{ name: 'prospects' }">
                        <div class="nav-logo logo-pos"></div>
                    </router-link>
                </div>
                <div class="nav-right">
                    <ProfileLink />
                    <HamburgerButton v-model="navExpanded" />
                </div>
            </div>
        </div>
        <div v-if="navExpanded" class="nav-type-1-expanded" ref="topNavExp">
                <div class="nav-center">
                    <CustomMenu class="nav-menu-main" :links="navLinks" />
                </div>

                <div class="nav-bottom">
                    <CustomMenu class="nav-menu-secondary" :links="navLinksSec" />
                </div>
        </div>
    </template>
</template>

<script>
    import { useUserStore } from '@/stores/user';
    import { useAccountStore } from '@/stores/account';
    import CustomMenu from '@/components/elements/navigation/CustomMenu';
    import ProfileLink from '@/components/elements/navigation/ProfileLink';
    import HamburgerButton from '@/components/elements/misc/HamburgerButton';
    import { useMainNavStore } from '@/stores/mainNav';

    export default {
        name: 'TopNav',
        components: {
            CustomMenu,
            HamburgerButton,
            ProfileLink
        },
        data() {
            return {
                navExpanded: false,
                navLinksMainPaid: [
                    {
                        route: { name: 'suspect' },
                        text: 'links.suspect',
                        icon: 'cards'
                    }
                ],
                navLinksMainFree: [
                    {
                        route: { name: 'subscriptions' },
                        text: 'links.suspect',
                        icon: 'cards',
                        class: 'paywall',
                        paywall: true
                    }
                ],
                navLinksMainBottom: [
                    {
                        route: { name: 'prospects' },
                        text: 'links.prospects',
                        icon: 'target'
                    }
                ],
                navLinksSecTop: [
                    {
                        route: { name: 'search' },
                        text: 'links.search',
                        icon: 'company',
                    }
                ],
                navLinksSecPaidAdmin: [
                    {
                        route: { name: 'users' },
                        text: 'links.users',
                        icon: 'team'
                    },
                ],
                navLinksSecFreeAdmin: [
                    {
                        route: { name: 'subscriptions' },
                        text: 'links.users',
                        icon: 'team',
                        class: 'paywall',
                        paywall: true
                    },
                ],
                navLinksSecPaidUser: [
                    {
                        route: { name: 'settings' },
                        text: 'links.settings',
                        icon: 'settings'
                    },
                ],
                navLinksSecFreeUser: [
                    {
                        route: { name: 'subscriptions' },
                        text: 'links.settings',
                        icon: 'settings',
                        class: 'paywall',
                        paywall: true
                    },
                ],
                navLinksSecAdmin: [
                    {
                        route: { name: 'subscriptions' },
                        text: 'links.subscriptions',
                        icon: 'card'
                    },
                ],
                navLinksSecBottom: [
                    {
                        url: "https://www.prospectpro.nl/klantenservice/",
                        text: 'links.customer_service',
                        icon: 'information'
                    },
                    {
                        function: this.logout,
                        text: 'links.signout',
                        icon: 'signout',
                        class: 'danger'
                    }
                ],
            }

        },
        computed: {
            userStore() {
                return useUserStore();
            },
            accountStore() {
                return useAccountStore();
            },
            paywall() {
                return (this.accountStore.paywall || !this.accountStore.isActive) && !this.userStore.isPartnerAdmin;
            },
            mainNav() {
                return useMainNavStore();
            },
            navLinks() {
                if(!this.paywall || this.userStore.isPartnerAdmin) {
                    return [
                        ...this.navLinksMainPaid,
                        ...this.navLinksMainBottom
                    ];
                } else {
                    return [
                        ...this.navLinksMainFree,
                        ...this.navLinksMainBottom
                    ];
                }
            },
            navLinksSec() {
                if(this.userStore.isPartnerAdmin || (this.accountStore.isAdmin && !this.paywall)) {
                    return [
                        ...this.navLinksSecTop,
                        ...this.navLinksSecPaidAdmin,
                        ...this.navLinksSecPaidUser,
                        ...this.navLinksSecAdmin,
                        ...this.navLinksSecBottom
                    ];
                } else if (this.accountStore.isAdmin) {
                    return [
                        ...this.navLinksSecTop,
                        ...this.navLinksSecFreeAdmin,
                        ...this.navLinksSecFreeUser,
                        ...this.navLinksSecAdmin,
                        ...this.navLinksSecBottom
                    ];
                } else if (!this.paywall) {
                    return [
                        ...this.navLinksSecTop,
                        ...this.navLinksSecPaidUser,
                        ...this.navLinksSecBottom
                    ];
                } else {
                    return [
                        ...this.navLinksSecTop,
                        ...this.navLinksSecFreeUser,
                        ...this.navLinksSecBottom
                    ];
                }
            }
        },
        methods: {
            toggleExpand(show = null) {
                this.navExpanded = typeof(show) === 'boolean' ? show : !this.navExpanded;
            },
            handleClick() {
                this.toggleExpand();
            },
            handleClickOutside(event) {
                if (this.navExpanded && !this.$refs.topNav.contains(event.target) && !this.$refs.topNavExp.contains(event.target)) {
                    this.toggleExpand(false);
                }
            },
            logout() {
                this.userStore.logout();
            },
        },
        watch: {
            $route() {
                this.toggleExpand(false);
            }
        },
        beforeMount() {
            document.addEventListener('click', this.handleClickOutside);
        },
        beforeUnmount() {
            document.removeEventListener('click', this.handleClickOutside);
            this.toggleExpand(false);
        },
    }
</script>